import { ChevronUpIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Checkbox,
  Collapse,
  Flex,
  HStack,
  Text,
  useDisclosure,
  VStack,
} from '@chakra-ui/react';

import type { TreeData } from '../../useTreeApi';

export function SelectedValuesDisplayComponent({
  selections,
  onRemove,
}: {
  selections: TreeData[];
  onRemove?: (selectionId: string) => void;
}) {
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: true });

  if (selections.length === 0) {
    return null;
  }

  return (
    <Flex direction="column" mb={4}>
      <HStack>
        <Button
          size="sm"
          variant="link"
          fontWeight={400}
          paddingTop={2}
          paddingLeft={1}
          colorScheme="navyBlue"
          onClick={onToggle}
        >
          <Text fontWeight={600} fontSize="sm">
            {`${selections.length} Selected`}
          </Text>
          <ChevronUpIcon
            boxSize={7}
            transform={isOpen ? 'rotate(180deg)' : undefined}
            transition="transform 0.2s"
          />
        </Button>
      </HStack>
      <Collapse in={isOpen}>
        <Box
          maxHeight="200px"
          overflowY="auto"
          onWheel={(e) => {
            e.stopPropagation();
          }}
        >
          <VStack align="stretch" spacing={2} py={2}>
            {selections.map((selection) => (
              <Checkbox
                key={selection.id}
                isChecked={true}
                colorScheme="green"
                variant="node-checkbox"
                onChange={(e) => {
                  if (!e.target.checked && onRemove) {
                    onRemove(selection.id);
                  }
                }}
              >
                <Text
                  fontSize="12px"
                  color="text.primary"
                  noOfLines={1}
                  whiteSpace="nowrap"
                  overflow="hidden"
                  textOverflow="ellipsis"
                >
                  {selection.name}
                </Text>
              </Checkbox>
            ))}
          </VStack>
        </Box>
      </Collapse>
    </Flex>
  );
}
